import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SpinnerComponent } from './spinner/spinner.component';
import { NoContentComponent } from "./no-content";
import { NotificationComponent } from "./notification";
import { ApiClient } from "./api-client.service";
import { CapslockDirective } from './capslock.directive';
import { CatalogsService, CatalogsResolve } from "./catalogs";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule
    ],
    declarations: [
        SpinnerComponent,
        NoContentComponent,
        NotificationComponent,
        CapslockDirective
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        SpinnerComponent,
        NoContentComponent,
        NotificationComponent,
        CapslockDirective
    ],
    providers: [
        ApiClient,
        CatalogsService,
        CatalogsResolve
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule { }


// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts